import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import MemberForm from '../Form';
import { createMember } from '@resources/Member/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createMember, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createMember(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.member.create',
						defaultMessage:
							'A new Member has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.member',
					defaultMessage: 'Create Member',
				})}
			</Title>
			<Section className="mb-5">
				<MemberForm onSubmit={handleSubmit} {...props} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	users,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		users,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createMember,
})(Create);
